import { render, staticRenderFns } from "./SoftVersionIcon.vue?vue&type=template&id=65e44900&scoped=true&"
import script from "./SoftVersionIcon.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SoftVersionIcon.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SoftVersionIcon.vue?vue&type=style&index=0&id=65e44900&lang=scss&scoped=true&"
import style1 from "./SoftVersionIcon.vue?vue&type=style&index=1&id=65e44900&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e44900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e44900')) {
      api.createRecord('65e44900', component.options)
    } else {
      api.reload('65e44900', component.options)
    }
    module.hot.accept("./SoftVersionIcon.vue?vue&type=template&id=65e44900&scoped=true&", function () {
      api.rerender('65e44900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/components/desktop/SoftVersionIcon.vue"
export default component.exports